import { Component,
    Directive,
    Input
} from '@angular/core';
import { ContextMenuService } from './context-menu.service';

@Directive( {
    selector: '[context-menu]',
    host: { '(contextmenu)': 'rightClick($event)' }
} )

export class ContextMenuDirective {
    @Input('context-menu') links;
    constructor(private menuService: ContextMenuService) {
    }

    rightClick(event: MouseEvent) {
        this.menuService.show.next({ event: event, obj: this.links });
        event.preventDefault();
    }
}



// WEBPACK FOOTER //
// ./src/common/context-menu/context-menu.directive.ts